import React from 'react';
import { toPersianNumber } from '../../../models/utils';
import './index.css';


const LearningBox = props => {
    const { lang, boxItem, index } = props;
    return (
        <a className={`card le-box-${index + 2} p-2-rem px-3 d-flex-column-between`}
            href={boxItem.href} target="_blank" rel="noopener noreferrer">
            <header className="text-center color-dark-blue font-bold font-12-px font-sm-14-px mb-2 px-3">
                {lang==='fa' ? boxItem.title.fa : boxItem.title.en}
            </header>
            <div className="le-box-number">{lang==='fa' ? toPersianNumber(index) : index }</div>
            <div className="le-box-image-wrapper">
                <img alt='' src={require(`../../../assets/images/learning-${index}.png`)} />
            </div>
        </a>
    );

}


export default LearningBox;
